var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('noscript',[_c('iframe',{staticStyle:{"display":"none","visibility":"hidden"},attrs:{"src":"https://www.googletagmanager.com/ns.html?id=GTM-TSR4KVG","height":"0","width":"0"}})]),_vm._v(" "),_c('transition',{attrs:{"name":"fade-transition","mode":"out-in"}},[_c('router-view')],1),_vm._v(" "),_c('snack-bar')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cf12086","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 